const contentTypeEnum = {
  URL: "URL",
  NEW_PAGE: "NEWPAGE",
  QR_CODE: "QRCODE",
  HTML: "HTML",
  POST: "POST",
};

export default contentTypeEnum;
